import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "jobstats row" }
const _hoisted_2 = { class: "col-xs-12 col-sm-4 job-stats-item" }
const _hoisted_3 = ["data-execcount"]
const _hoisted_4 = { class: "text-table-header" }
const _hoisted_5 = {
  key: 0,
  class: "col-xs-12 col-sm-4 job-stats-item"
}
const _hoisted_6 = ["data-successrate"]
const _hoisted_7 = { class: "text-table-header" }
const _hoisted_8 = { class: "col-xs-12 col-sm-4 job-stats-item" }
const _hoisted_9 = ["data-avgduration"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_12 = { class: "text-table-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_socket = _resolveComponent("ui-socket")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ui_socket, {
      section: "job-stats-basic",
      location: "exec-count"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            id: "jobstat_execcount_total",
            class: "job-stats-value",
            "data-execcount": _ctx.execCount
          }, _toDisplayString(_ctx.formatNumber(_ctx.execCount)), 9, _hoisted_3),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("execution", _ctx.execCount)), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ui_socket, {
      section: "job-stats-basic",
      location: "success-rate"
    }, {
      default: _withCtx(() => [
        (_ctx.successrate > -1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", {
                class: _normalizeClass(["job-stats-value", _ctx.successColor]),
                "data-successrate": _ctx.successrate
              }, _toDisplayString(_ctx.formatPercent(_ctx.successrate)), 11, _hoisted_6),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("success.rate")), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ui_socket, {
      section: "job-stats-basic",
      location: "average-duration"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", {
            class: "job-stats-value",
            "data-avgduration": _ctx.avgduration
          }, [
            (_ctx.avgduration > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.formatDuration(_ctx.avgduration)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, "-"))
          ], 8, _hoisted_9),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("average.duration")), 1)
        ])
      ]),
      _: 1
    })
  ]))
}